import { Component, Inject, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import { AdminSettingsService } from 'src/app/_services/admin-settings.service';
import Swal from 'sweetalert2';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatCalendar } from '@angular/material/datepicker';
import * as moment from 'moment';

const MY_DATE_FORMAT = {
  parse: {
    dateInput: 'DD/MM/YYYY', // Formato di parsing della data
  },
  display: {
    dateInput: 'DD/MM/YYYY', // Formato di visualizzazione della data
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY'
  }
};

@Component({
  selector: 'app-concludi-collaborazione',
  templateUrl: './concludi-collaborazione.component.html',
  styleUrls: ['./concludi-collaborazione.component.css'],
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMAT },
    { provide: MAT_DATE_LOCALE, useValue: 'it-IT' }
  ]
})
export class ConcludiCollaborazioneComponent {
  @ViewChild('calendar') calendar: MatCalendar<any>;
  deleteUser: FormGroup;
  startDate: Date | null = null;
  endDate: Date | null = null;

  // Variabili per gestire i listener
  private isUpdatingForm = false;

  constructor(
    private fb: FormBuilder,
    private modal: NzModalRef,
    private adminSettingsService: AdminSettingsService,
    @Inject(NZ_MODAL_DATA) public data: any
  ) {
    this.startDate = this.data.data.start_date;
    this.endDate = this.data.data.end_date;
  }

  ngOnInit(): void {
    this.deleteUser = this.fb.group({
      endwork_date: [null], // Campo data
      billing: [false, Validators.required] // Checkbox
    });
    // Aggiorna lo stato iniziale del form
    this.updateFormState();

    // Ascolta i cambiamenti della checkbox
    this.deleteUser.get('billing')?.valueChanges.subscribe((checked) => {
      if (!this.isUpdatingForm) {
        this.isUpdatingForm = true; // Disabilita i listener
        this.updateFormState();
        this.isUpdatingForm = false; // Riabilita i listener
      }
    });

    // Ascolta i cambiamenti della data
    this.deleteUser.get('endwork_date')?.valueChanges.subscribe((value) => {
      if (!this.isUpdatingForm) {
        this.isUpdatingForm = true; // Disabilita i listener
        this.updateFormState();
        this.isUpdatingForm = false; // Riabilita i listener
      }
    });
  }

  /**
   * Aggiorna lo stato del form in base ai valori correnti.
   */
  updateFormState(): void {
    const billingChecked = this.deleteUser.get('billing')?.value;
    const endworkDateValue = this.deleteUser.get('endwork_date')?.value;

    if (billingChecked) {
      // Se la checkbox è selezionata, disabilita il campo data e resetta il valore
      this.deleteUser.get('endwork_date')?.disable();
      this.deleteUser.get('endwork_date')?.setValue(null);
    } else {
      // Se la checkbox non è selezionata, abilita il campo data
      this.deleteUser.get('endwork_date')?.enable();
    }

    if (endworkDateValue) {
      // Se è stata selezionata una data, disabilita la checkbox
      this.deleteUser.get('billing')?.disable();
    } else {
      // Se non è stata selezionata una data, abilita la checkbox
      this.deleteUser.get('billing')?.enable();
    }
  }

  /**
   * Conferma la conclusione della collaborazione.
   */
  delMember(): void {
    if (this.deleteUser.valid) {
      const endworkDate = this.deleteUser.value.endwork_date;
      const formattedDate = endworkDate ? moment(endworkDate).format('YYYY-MM-DD') : null; // Formato "YYYY-MM-DD"
      const useLastBillingDate = this.deleteUser.value.billing;

      const data = {
        project_user_id: this.data.data.project_user_id,
        endwork_date: formattedDate,
        billing: useLastBillingDate
      };

      this.adminSettingsService.endWork(data).subscribe({
        next: (res: any) => {
          Swal.fire({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 2000,
            timerProgressBar: true,
            icon: 'success',
            iconColor: '#FFB26B',
            title: res.message,
            didOpen: (toast) => {
              toast.addEventListener('mouseenter', Swal.stopTimer);
              toast.addEventListener('mouseleave', Swal.resumeTimer);
            },
          });
          this.modal.destroy('success');
        },
        error: (err) => {
          Swal.fire({
            icon: 'error',
            title: 'Errore',
            text: 'Si è verificato un errore durante la conclusione della collaborazione.',
          });
        }
      });
    }
  }

  /**
   * Chiude il modal senza salvare.
   */
  handleCancel(): void {
    this.modal.destroy();
  }
}